import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { MessService } from '../mess.service';
import moment from 'moment';
import { CellValueChangedEvent, ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { AddItemDialogComponent } from '../add-item-dialog/add-item-dialog.component';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { SupplyBuildingDialogComponent } from '../supply-building-dialog/supply-building-dialog.component';
import { Router } from '@angular/router';

export interface PeriodicElement2 {
  messBuildingId: any;
  messBuildingName: any;
  daysheetDate: any;
  status: any;
  studentCount: any;
  employeeCount: any;
  subStaffCount: any;
  visitorsCount: any;
}


@Component({
  selector: 'app-mess-closed-details',
  templateUrl: './mess-closed-details.component.html',
  styleUrls: ['./mess-closed-details.component.scss']
})
export class MessClosedDetailsComponent implements OnInit {
  @ViewChild('searchInputcampus') searchInputcampus!: ElementRef;
  gridApi!: GridApi;
  quickFilter: string = '';

  constructor(private service: MessService,
    private spinner: NgxSpinnerService,
    private toast: ToastmessageService,
    private router: Router) { }
  ngOnInit(): void {
    this.closedList();
  }

  onRowClicked(event: any) {
    const { messBuildingId, daysheetDate, messBuildingName } = event.data;
    const queryParams: Record<string, string | number> = {
      messBuildingId,
      daysheetDate,
      messBuildingName,
    };

    // Landing shell: list → excel via setView (same pattern as mess-do-details)
    if (this.router.url.includes('MessDetails')) {
      this.service.setMessExcelParams(queryParams);
      this.service.setView('messExcelDetails');
      return;
    }

    this.router.navigate(['/messExcelDetails'], { queryParams });
  }


  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }

  onfilterChange(event: any) {
    this.quickFilter = event.target.value;
  }

  focusSearchInput() {
    setTimeout(() => {
      if (this.searchInputcampus) {
        this.searchInputcampus.nativeElement.focus();
      }
    }, 100);
  }


  colDefs: ColDef[] = [

    {
      headerName: 'S.No',
      pinned: 'left',
      width: 70,
      cellStyle: { 'text-align': 'center', 'font-size': '16px' },
      valueGetter: (params: any) => params.node.rowIndex + 1,
    },
    {
      field: 'messBuildingName',
      headerName: 'Kitchen Name',
      pinned: 'left',
      width: 300,
      cellStyle: { 'text-align': 'left', 'font-size': '16px' },
    },
    {
      field: 'daysheetDate',
      headerName: 'Daysheet Date',
      cellStyle: { 'text-align': 'left', 'font-size': '16px' },
    },
    {
      field: 'studentCount',
      headerName: 'Student Count',
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
    },
    {
      field: 'employeeCount',
      headerName: 'Employee Count',
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
    },
    {
      field: 'subStaffCount',
      headerName: 'SubStaff Count',
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
    },
    {
      field: 'visitorsCount',
      headerName: 'Others Count',
      cellStyle: { 'text-align': 'right', 'font-size': '16px' },
    },
    {
      field: 'status',
      headerName: 'Status',
      cellStyle: { 'text-align': 'left', 'font-size': '16px' },
    },

  ];


  rowData: PeriodicElement2[] = [];

  defaultColDef: ColDef = {
    flex: 1,
    menuTabs: [],
    suppressHeaderMenuButton: true,
    sortable: true,
    filter: false,
  };

  // ✅ custom overlay text
  overlayLoadingTemplate = `
      <span class="ag-overlay-loading-center">
        Please wait while data is loading...
      </span>`;

  overlayNoRowsTemplate = `
      <span>No data found</span>`;

  closedList() {
    this.gridApi?.showLoadingOverlay();
    this.spinner.show();
    this.service.getCloseDetails().subscribe({
      next: (res: any) => {
        if (!res || res == 204) {
          this.spinner.hide();
          this.gridApi?.showNoRowsOverlay();
          this.rowData = [];
        }
        this.rowData = Array.isArray(res) ? [...res].reverse() : res;
        // this.rowData = Array.isArray(res) ? res.map((r: any) => this.normalizeInventoryRow(r)) : []; 
        // console.log('res', res);
        this.gridApi?.hideOverlay();
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
        this.gridApi?.hideOverlay();
      }
    })
  }


}
